import { RootState } from 'store';
import { useCallback } from 'react';
import { useSelector } from 'react-redux';
import {
  checkIsLoading,
  checkIsLoadingDone
} from 'common/utils/checkLoading';

import { CARS_STATE } from '../../constants';

import { EMPTY_ARRAY } from 'shared/constants';

const useCarEBoxLocationsLoadingStatus = () => {
  const carsEBoxLocationsLoadingStatus = useSelector((state: RootState) => state[CARS_STATE].eBoxLocations.loadingStatus);
  return carsEBoxLocationsLoadingStatus;
};

export const useIsCarEBoxLocationsLoading = () => {
  const carEBoxLocationsLoadingStatus = useCarEBoxLocationsLoadingStatus();
  return checkIsLoading(carEBoxLocationsLoadingStatus);
};

export const useIsCarEBoxLocationsDone = () => {
  const carEBoxLocationsLoadingStatus = useCarEBoxLocationsLoadingStatus();
  return checkIsLoadingDone(carEBoxLocationsLoadingStatus);
};

export const useCarEBoxLocations = () => {
  const carEBoxLocations = useSelector((state: RootState) => state[CARS_STATE].eBoxLocations.data);
  return carEBoxLocations;
};

export const useCars = () => {
  return useSelector((state: RootState) => state[CARS_STATE].eBoxLocations.data);
};

export const useFilterCarEBoxLocationsByAutoNumberOrObuNumber = () => {
  const carEBoxLocations = useCarEBoxLocations() || EMPTY_ARRAY;

  const filterCarEBoxLocationsByAutoNumberOrObuNumber = useCallback((value: string) => (
    carEBoxLocations.filter(({ autoNumber, obuNumber }) => (
      autoNumber.toLowerCase().includes(value.toLowerCase()) ||
      obuNumber.toLowerCase().includes(value.toLowerCase())
    ))
  ), [carEBoxLocations]);

  return filterCarEBoxLocationsByAutoNumberOrObuNumber;
};

export const useHasCarEBoxLocations = () => {
  const carEBoxLocations = useCarEBoxLocations() || [];
  return !!carEBoxLocations.length;
};
